import React , { useState, useEffect} from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as Icon from 'react-bootstrap-icons';
import product from './product.json';

export default function Product () {
    // Product.json
    const [items, setItems] = useState([]);

    // Fetching product product from json file
    useEffect(() => {
        setItems(product);
    }, []);
    
    //Add amount
    const [score, setScore] = useState(1);

    function priceMinus(price, score) {
        let latestScore = score - 1;
        let totalPrice = price * latestScore;
        let finalPrice = (Math.round(totalPrice*100)/100).toFixed(2);
        document.getElementById("totalPrice").innerHTML = `Add to cart - RM ${finalPrice}`;
        document.getElementById("updatedQuantity").innerHTML = latestScore;
    }

    function priceAdd(price, score) {
        let latestScore = score + 1;
        let totalPrice = price * latestScore;
        let finalPrice = (Math.round(totalPrice*100)/100).toFixed(2);
        document.getElementById("totalPrice").innerHTML = `Add to cart - RM ${finalPrice}`;
        document.getElementById("updatedQuantity").innerHTML = latestScore;
    }

    return (
        <div className='container small-device'>
            <div className='container'>
                {items.map((item) => (
                    <Row className='py-5'>
                        <Col sm={4}>
                            <img src={item.image} className='product-image' alt='shop1'></img>
                        </Col>
                        <Col sm={8}>
                            <a href='shop' className='item-name brand-color fs-3'>
                                <p><Icon.ChevronCompactLeft color='brand-color' size={40}/> {item.productName}</p>                            
                            </a>
                            <p>{item.description}</p>                                                   
                            <div className='py-4 d-grid gap-2 d-md-flex'>                                
                                <h3 className='d-md-flex pt-2 pe-2'>Quantity : </h3>                                  
                                <div className='d-md-flex'>
                                    <button
                                        onClick={() => {
                                            setScore(score - 1);
                                            priceMinus(item.price, score)
                                        }}
                                        className='item-quantity'>-</button>
                                    <h1 id='updatedQuantity' className='item-num'>1</h1>
                                    <button
                                        onClick={() => {
                                            setScore(score + 1);
                                            priceAdd(item.price, score)
                                        }}
                                        className='item-quantity'>+ </button>
                                </div>                                
                                <div className='d-md-flex ps-3'>
                                    <button type='button' id='totalPrice' className='btn login'>Add to cart - RM {item.price}</button>
                                </div>
                            </div> 
                            
                        </Col>           
                    </Row>   
                ))}    
            </div>  
        </div>
    );
}